// extracted by mini-css-extract-plugin
export default {"wrapper":"Dv-z","button":"Ev-z","alternate":"Fv-z","disabled":"Gv-z","paymentWarning":"Hv-z","fadeIn":"Iv-z"};